import { render, staticRenderFns } from "./referal_reports.vue?vue&type=template&id=0a70e525&"
import script from "./referal_reports.vue?vue&type=script&lang=js&"
export * from "./referal_reports.vue?vue&type=script&lang=js&"
import style0 from "./referal_reports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue/rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports